module.exports = __webpack_public_path__ + "static/media/ww_ecs1.667cf61f.gif";